import type { LandingStrings } from './en';

export const pl: LandingStrings = {
  header: {
    brandSubtitle: 'Magiczny sklep',
    contact: 'Kontakt',
    about: 'O grze',
    language: 'Język',
  },
  footer: {
    terms: 'Warunki użytkowania',
    privacy: 'Polityka prywatności',
    copyright: '{year} {holder}. Wszelkie prawa zastrzeżone.',
  },
  home: {
    heroTitle: 'Przytulna gra 3D o eliksirach i magicznym sklepie.',
    heroDescription:
      'Szukaj składników w magicznym chaosie, warz eliksiry w kotle i sprzedawaj je we własnym sklepie.',
    features: [
      {
        title: 'Własny flakon',
        desc: 'Kształt, zakrętka i kolor eliksiru — ładniejsze flakony sprzedają się drożej.',
      },
      {
        title: 'Rzemiosło z sensem',
        desc: 'Każdy eliksir ma własny przepis, a wiele z nich naprawdę działa w grze.',
      },
      {
        title: 'Historia, którą chce się śledzić',
        desc: 'Babcia wyjechała na wakacje i zostawiła ci swój sklep, a żaba imieniem Moren domaga się swego.',
      },
      {
        title: 'Sklep, który naprawdę jest twój',
        desc: 'Na sprzedaż trafia tylko to, co uwarzysz własnymi rękami.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Już wkrótce',
    tags: { search: 'Szukanie po cieniach', craft: 'Warzenie w 3D', shop: 'Przytulny sklep' },
  },
  about: {
    title: 'O grze Qevryno',
    intro: [
      'Witaj w Qevryno — przytulnej grze o warzeniu eliksirów, w której magię tworzy się własnymi rękami.',
      'Babcia wyjechała na wakacje i poprosiła cię o opiekę nad swoim tajemniczym starym domem: zapomniane przepisy, magiczne składniki i kocioł, który wciąż pamięta, jak bulgotać. Na dole jest mały sklep, a cała wioska zastanawia się, kto się nim teraz zajmuje.',
      'Warz eliksiry, dbaj o puszystego chowańca, sprzedawaj swoje dzieła uroczym klientom i zarabiaj monety na ozdabianie magicznego domu — we własnym tempie, bez zegarów, które poganiają.',
    ],
    whatTitle: 'Co to za gra?',
    what: [
      'Qevryno to relaksująca łamigłówka 3D, w której łączą się szukanie ukrytych przedmiotów, alchemiczne rzemiosło i mały symulator sklepu. Jeśli lubisz przytulne gry (cozy games), gry casualowe i zagadki, szukanie ukrytych przedmiotów, gry o eliksirach i miksturach, alchemię i prowadzenie własnego magicznego sklepu — to gra dla ciebie.',
      'To gra dla jednego gracza, która działa bez internetu; sieć jest potrzebna tylko do zakupów i opcjonalnych filmów z nagrodą. Nie ma banerów ani wyskakujących reklam: krótki film Google AdMob za bonus włącza się tylko wtedy, gdy go wybierzesz. Opcjonalne zakupy: klejnoty i zestawy składników z widoczną zawartością. Wkrótce na iOS i Androida, w językach: angielskim, rosyjskim, hiszpańskim, niemieckim, francuskim, niderlandzkim, włoskim, portugalskim (Brazylia), polskim, japońskim, koreańskim, chińskim tradycyjnym i tureckim.',
    ],
    doTitle: 'Co będziesz robić',
    doList: [
      'Szukać ukrytych składników na magicznych leśnych polanach 3D — każda jest jak mała diorama.',
      'Warzyć w kotle eliksiry według magicznych przepisów: stabilizator, główny składnik, zioła czasu i odrobina koloru.',
      'Projektować własne flakony — kształt, zakrętka, kolor eliksiru; ładniejsze sprzedają się drożej.',
      'Prowadzić własny sklep: klienci, reputacja, jarmarki i zadania.',
      'Śledzić historię: babcia wyjechała na wakacje i zostawiła ci swój sklep, a żaba imieniem Moren wciąż domaga się swego.',
      'Ucierać znaleziska w moździerzu, mieszać je w misce i dosypywać brokatu — każda mieszanka ma własną fakturę i kolor.',
      'Karmić chowańca i dekorować sklep.',
    ],
    faqTitle: 'Częste pytania',
    faq: [
      { q: 'Czy Qevryno jest bezpłatna?', a: 'Tak. Gra jest bezpłatna i można w nią grać bez płacenia. Opcjonalne zakupy: klejnoty i zestawy składników.' },
      { q: 'Czy działa bez internetu?', a: 'Tak. Sama gra nie potrzebuje sieci — warz eliksiry w samolocie albo pod kocem. Internet jest potrzebny tylko do zakupów i opcjonalnych filmów z nagrodą.' },
      { q: 'Czy są reklamy?', a: 'Tylko opcjonalne. Nie ma banerów ani wyskakujących reklam między ekranami. W kilku miejscach możesz, jeśli chcesz, obejrzeć krótki film i dostać bonus — na przykład manę. Nic w grze nie wymaga ich oglądania. Filmy wyświetla Google AdMob; szczegóły znajdziesz w Polityce prywatności.' },
      { q: 'Na jakich platformach?', a: 'iOS i Android, w językach: angielskim, rosyjskim, hiszpańskim, niemieckim, francuskim, niderlandzkim, włoskim, portugalskim (Brazylia), polskim, japońskim, koreańskim, chińskim tradycyjnym i tureckim.' },
      { q: 'Czy jest straszna albo stresująca?', a: 'Wcale nie. To spokojna, przytulna gra: łagodna muzyka, żadnych kar za błędy i kot w kapeluszu.' },
    ],
  },
  contact: {
    title: 'Skontaktuj się z nami',
    subtitle: 'Pytanie o Qevryno, błąd, zakup albo reklama? Napisz do nas e-maila.',
    write: 'Napisz e-mail',
    mailSubject: 'Qevryno: pomoc',
    tip: 'Napisz, jakiego urządzenia używasz i co się stało — tak łatwiej nam pomóc.',
    info: {
      title: 'Dane kontaktowe',
      email: 'E-mail',
      security: 'Bezpieczeństwo',
      legalName: 'Deweloper',
      address: 'Adres',
    },
    refunds: {
      title: 'Zwroty i zakupy',
      description: 'Wszystkie zakupy odbywają się przez Apple App Store lub Google Play. Aby odzyskać pieniądze, skontaktuj się ze sklepem z aplikacjami:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/pl-pl/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=pl',
      link: 'Poproś o zwrot',
      note: 'Nie przyjmujemy płatności bezpośrednio i nie możemy zwracać pieniędzy. Jeśli zakup nie dotarł do gry, otwórz „Ustawienia → Przywróć zakupy” albo napisz do nas.',
    },
  },
  legal: {
    dataController: 'Administrator danych',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: 'Ten dokument jest dostępny tylko po angielsku, rosyjsku i hiszpańsku. Poniżej wersja angielska.',
  },
};
